module.exports = __webpack_public_path__ + "static/media/BillIcon.6a353550.svg";